import React, { Suspense, useCallback, useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import { useDispatch } from "react-redux";
import { ProfileDetailThunk } from "../../slices/auth/login/thunk";
import WelcomeModal from "../../Components/Modals/WelcomeModal";
import AmountCard from "../../Components/Cards/AmountCard";
import {
  home_finance_ledgerThunk,
  home_investment_summeryThunk,
  home_investment_withdrawalThunk,
  home_total_returnsThunk,
  home_tradeConfirmationDataThunk,
  home_tradeConfirmationMonthsThunk,
} from "../../slices/thunks";
import { useSelector } from "react-redux";
import AmountCardSkeleton from "../../Components/Skeleton/AmountCardSkeleton";
import RadialBarChart from "../../Components/Graphs/RadialBarChart";
// import InvestmentChart from "../../Components/Graphs/InvestmentChart";
import classnames from "classnames";
import Home_financial_ledger from "./Home_financial_ledger";
import Last_Month_Reports from "./Last_Month_Reports";
import Home_Portfolio from "./Home_Portfolio";
import NewsnAnnouncements from "./NewsnAnnouncements";
// import HeatmapCharts from "../../Components/Graphs/HeatmapCharts";
import HeatMapChartSkeleton from "../../Components/Skeleton/HeatMapChartSkeleton";
import InvestmentSummerySkeleton from "../../Components/Skeleton/InvestmentSummerySkeleton";
import investmentIcon from "../../assets/images/homeIcons/totalInvested.svg";
import withdrawalIcon from "../../assets/images/homeIcons/withdrawal.svg";
import totalReturnIcon from "../../assets/images/homeIcons/totalReturn.svg";
import { useLazyLoad } from "../../Components/Hooks/useLazyLoad";
const HeatmapCharts = React.lazy(() =>
  import("../../Components/Graphs/HeatmapCharts")
);
const InvestmentChart = React.lazy(() =>
  import("../../Components/Graphs/InvestmentChart")
);

const DashboardEcommerce = () => {
  document.title = "Dashboard | B.N. Rathi";
  const [showModal, setShowModal] = useState(true);

  const onCloseClick = () => {
    setShowModal(false);
    sessionStorage.setItem("welcomeModalShown", "false");
  };

  const { userData } = usePersistStoreData();
  const token = userData?.token;
  const dispatch = useDispatch();
  const [investmentMonth, setInvestmentMonth] = useState("6");
  const getCurrentMonthFormat = () => {
    const now = new Date();
    // Get short month name (Jan, Feb, etc.)
    const month = now.toLocaleString("en-US", { month: "short" });
    // Get last two digits of year
    const year = now.getFullYear().toString().slice(-2);
    return `${month}-${year}`;
  };
  const [tradeConfirmMonth, setTradeConfirmMonth] = useState(
    getCurrentMonthFormat()
  );

  //Tab
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const [rightColumn, setRightColumn] = useState(true);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };

  const dataColors = JSON.stringify([
    "#e9ebec",
    "#FFE0C2",
    "#FFD1A3",
    "#FFC184",
    "#FFB265",
    "#E69F55",
  ]);

  const params = {
    timePeriod: "6",
  };

  //handle investment summery filter
  const handleFilterInvestment = (event) => {
    const selectedValue = event.target.value;
    setInvestmentMonth(selectedValue);
    dispatch(
      home_investment_summeryThunk({
        token,
        params: { timePeriod: selectedValue },
      })
    );
  };

  //handle trade confirmation months filter
  const handleFilterTradeConfirmation = (event) => {
    const selectedValue = event.target.value;
    setTradeConfirmMonth(selectedValue);
    dispatch(
      home_tradeConfirmationDataThunk({
        token,
        params: { month: selectedValue },
      })
    );
  };

  const { investmentWithdrawalData, investmentWithdrawalLoading } = useSelector(
    (state) => state.Home_Investment_Withdrawal
  );
  const { totalReturnsData, totalReturnsLoading } = useSelector(
    (state) => state.Home_Total_Returns
  );
  const { investmentSummeryData, investmentSummeryLoading } = useSelector(
    (state) => state.Home_Investment_Summery
  );
  
  const { home_tradeConfirmMonthsData, home_tradeConfirmMonthsLoading } =
    useSelector((state) => state.Home_TradeConfirmMonths);
  const { home_tradeConfirmData, home_tradeConfirmLoading } = useSelector(
    (state) => state.Home_TradeConfirm
  );

  useEffect(() => {
    dispatch(ProfileDetailThunk(userData?.token)),
      dispatch(home_investment_withdrawalThunk({ token }));
    dispatch(home_total_returnsThunk({ token }));
    dispatch(home_tradeConfirmationMonthsThunk({ token }));
    // dispatch(
    //   home_tradeConfirmationDataThunk({
    //     params: { month: tradeConfirmMonth },
    //     token,
    //   })
    // );

    // dispatch(
    //   home_investment_summeryThunk({
    //     params: { timePeriod: investmentMonth },
    //     token,
    //   })
    // );
  }, []);

  const loadChartData = useCallback(() => {
    dispatch(
      home_tradeConfirmationDataThunk({
        params: { month: tradeConfirmMonth },
        token,
      })
    );
  }, [tradeConfirmMonth]);

  const { targetRef, isVisible } = useLazyLoad(loadChartData);

  const loadInvestmentData = useCallback(() => {
    dispatch(
      home_investment_summeryThunk({
        params: { timePeriod: investmentMonth },
        token,
      })
    );
  }, [dispatch, investmentMonth, token]);

  // Use lazy load hook for investment chart
  const { targetRef: investmentRef, isVisible: investmentVisible } =
    useLazyLoad(loadInvestmentData);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={
              <>
                Hi {userData?.name},{" "}
                <span style={{ fontWeight: 400 }}>Welcome to B.N.Rathi</span>
              </>
            }
            description="Here's what's happening with your account today"
          />
          <Row>
            <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
              <Row className="h-100">
                <Col xxl={4} xl={4} lg={4} md={6} sm={12} xs={12}>
                  {investmentWithdrawalLoading ? (
                    <AmountCardSkeleton />
                  ) : (
                    <AmountCard
                      amount={investmentWithdrawalData?.total_investment ?? 0}
                      icon={investmentIcon}
                      inrIcon={true}
                      title="TOTAL INVESTED"
                    />
                  )}
                </Col>
                <Col xxl={4} xl={4} lg={4} md={6} sm={12} xs={12}>
                  {investmentWithdrawalLoading ? (
                    <AmountCardSkeleton />
                  ) : (
                    <AmountCard
                      amount={investmentWithdrawalData?.total_withdrawl ?? 0}
                      icon={withdrawalIcon}
                      inrIcon={true}
                      title="TOTAL WITHDRAWAL"
                    />
                  )}
                </Col>
                <Col xxl={4} xl={4} lg={4} md={6} sm={12} xs={12}>
                  {totalReturnsLoading ? (
                    <AmountCardSkeleton />
                  ) : (
                    <AmountCard
                      amount={totalReturnsData?.total_returns ?? 0}
                      icon={totalReturnIcon}
                      inrIcon={true}
                      title="TOTAL RETURN"
                    />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          {/* Financial Ledger and portfolio data  */}
          <Row>
            <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
              <Card className="card-height-100">
                <CardBody className="mb-2 pt-1 pb-0">
                  <div>
                    <Nav
                      className="nav-tabs nav-tabs-custom nav-tabs_home"
                      role="tablist"
                    >
                      <NavItem>
                        <NavLink
                          href="#"
                          className={classnames({ active: activeTab === "1" })}
                          onClick={() => {
                            toggleTab("1");
                          }}
                        >
                          <span className="text-dark fs-12 fw-medium">
                            Financial Ledger
                          </span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          href="#"
                          className={classnames({ active: activeTab === "2" })}
                          onClick={() => {
                            toggleTab("2");
                          }}
                        >
                          <span className="text-dark fs-12 fw-medium">
                            Portfolio
                          </span>
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                  <div>
                    <TabContent activeTab={activeTab} className="">
                      <TabPane tabId="1">
                        <Home_financial_ledger />
                      </TabPane>
                      <TabPane tabId="2">
                        <Home_Portfolio />
                      </TabPane>
                    </TabContent>
                  </div>
                </CardBody>
              </Card>
            </Col>
            {/* <Col xxl={4} xl={4} lg={12} md={12} sm={12} xs={12}>
              <NewsnAnnouncements />
            </Col> */}
          </Row>
          {/* investment summery start */}
          <Row>
            <Col xxl={4} xl={4} lg={6} md={12} sm={12} xs={12}>
              <Last_Month_Reports />
            </Col>
            {investmentSummeryLoading ? (
              <InvestmentSummerySkeleton />
            ) : (
              <Col xxl={8} xl={8} lg={6} md={12} sm={12} xs={12}>
                <div
                  ref={investmentRef}
                  style={{ minHeight: investmentVisible ? "auto" : "150px" }}
                >
                  {investmentVisible && (
                    <Card className="card-height-100">
                      <CardBody className="">
                        <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap">
                          <div className="mb-2">
                            <h4 className="text-dark mb-0">
                              Investment Summary
                            </h4>
                            {investmentSummeryData?.as_on_date && (
                              <p className="mb-0 fs-14 fw-medium text-muted">
                                <i className="me-1 ri-time-line align-middle fs-14"></i>
                                Updated on{" "}
                                <span className="text-primary">
                                  {investmentSummeryData?.as_on_date}
                                </span>
                              </p>
                            )}
                          </div>
                          <div className="d-flex align-items-center gap-2 mt-2 mt-md-0">
                            <span
                              className="text-dark fs-14 fw-medium"
                              style={{ minWidth: "150px" }}
                            >
                              Select Month Range
                            </span>
                            <Input
                              type="select"
                              value={investmentMonth}
                              onChange={handleFilterInvestment}
                              className="fs-12 fw-medium text-muted"
                              style={{ minWidth: "120px" }}
                            >
                              <option value="6">6 Month</option>
                              <option value="12">Current F.Y.</option>
                            </Input>
                          </div>
                        </div>
                        <div>
                          <div id="chart">
                            <Suspense
                              fallback={
                                <div
                                  className="centerContent"
                                  style={{ height: 350 }}
                                >
                                  Loading Chart...
                                </div>
                              }
                            >
                              <InvestmentChart
                                investmentSummeryData={investmentSummeryData}
                                height={350}
                              />
                            </Suspense>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  )}
                </div>
              </Col>
            )}
          </Row>

          {/* Heat map chart */}
          <Row>
            <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
              <Card className="card-height-100">
                <CardBody className="">
                  <div className="d-flex align-items-center justify-content-between mb-0 flex-wrap">
                    <div className="">
                      <h4 className="text-dark mb-0">
                        Your daily Trade Overview
                      </h4>
                      {home_tradeConfirmData?.as_on_date && (
                        <p className="mb-0 fs-14 fw-medium text-muted">
                          <i className="me-1 ri-time-line align-middle fs-14"></i>
                          Updated on{" "}
                          <span className="text-primary">
                            {home_tradeConfirmData?.as_on_date}
                          </span>
                        </p>
                      )}
                    </div>
                    <div className="d-flex align-items-center gap-2 mt-2 mt-md-0">
                      <span
                        className="text-dark fs-14 fw-medium"
                        style={{ minWidth: "100px" }}
                      >
                        Select Month
                      </span>
                      <Input
                        // style={{width:'40%'}}
                        type="select"
                        value={tradeConfirmMonth}
                        onChange={handleFilterTradeConfirmation}
                        className="fs-12 fw-medium text-muted"
                        style={{ minWidth: "120px" }}
                        disabled={home_tradeConfirmMonthsLoading}
                      >
                        {home_tradeConfirmMonthsLoading ? (
                          <option>Loading...</option>
                        ) : (
                          Object.entries(home_tradeConfirmMonthsData).map(
                            ([key, value], index) => (
                              <option value={key} key={index}>
                                {value}
                              </option>
                            )
                          )
                        )}
                      </Input>
                    </div>
                  </div>
                  <div
                    ref={targetRef}
                    className="chart-section"
                    // style={{ minHeight: isVisible ? '50px' : '50px' }}
                  >
                    {isVisible && (
                      <Suspense fallback={<HeatMapChartSkeleton />}>
                        {home_tradeConfirmLoading ? (
                          <HeatMapChartSkeleton />
                        ) : (
                          <HeatmapCharts />
                        )}
                      </Suspense>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* access to last month report */}
          {/* <Row>
            <Col xxl={4} xl={6} lg={6} md={6} sm={12} xs={12}>
            <Last_Month_Reports />
            </Col>
            <Col xxl={4} xl={6} lg={6} md={6} sm={12} xs={12}>
            <Last_Month_Reports />
            </Col>
            <Col xxl={4} xl={6} lg={6} md={6} sm={12} xs={12}>
            <Last_Month_Reports />
            </Col>
          </Row> */}
        </Container>
      </div>
      {showModal && userData?.profile_progress < 100 ? (
        <WelcomeModal
          showModal={showModal}
          onCloseClick={onCloseClick}
          setShowModal={setShowModal}
        />
      ) : null}
    </React.Fragment>
  );
};

export default DashboardEcommerce;
